import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import services from 'api/services';
import { useFreecodeContextData } from 'hooks/useContext';
import { RoundIconButton } from 'components/Button/IconButton';

import { buttonIds } from 'components/FreecodePage/FreecodeLayout/FreecodeLayoutConstants';
import { useExportZip } from './exportFreecode';
const { TestService } = services;

export default function CreatorInspectButtons() {
  const navigate = useNavigate();
  const { test } = useFreecodeContextData();

  const [exportZip, exporting] = useExportZip();

  const [copying, setCopying] = useState(false);

  const copyFreecode = async () => {
    try {
      if (!test) return toast.error('Test Not Found');
      if (copying) return toast.error('Already Copying');
      setCopying(true);

      let response = await TestService.copyFreecode(test._id);
      if (!response?.test?._id) {
        toast.error('Copy did not return a new test id');
      } else {
        toast.success('Freecode copied successfully');
        navigate(`/freecode-creator/${response?.test?._id}`);
      }
    } catch (e) {
      toast.error(typeof e === 'string' ? e : e?.message || 'Could not copy');
    }
    setCopying(false);
  };

  return (
    <>
      <RoundIconButton
        id={buttonIds.exportButton}
        title="Export Freecode Zip"
        onClick={exportZip}
        icon={exporting ? 'fa fa-spinner' : 'fa fa-download'}
        spinner={exporting}
      />
      <RoundIconButton
        id={buttonIds.wikiLink}
        icon="fa-brands fa-wikipedia-w"
        title="Go to the Wiki"
        onClick={() => window.open('https://wiki.futureskill.com/index.php/Freecode_creator', '_blank')}
      />
      <RoundIconButton
        id={buttonIds.copyButton}
        title="Copy Freecode"
        onClick={copyFreecode}
        icon={copying ? 'fa fa-spinner' : 'fa fa-copy'}
      />
    </>
  );
}
